import React from "react";

/**
 * BuyerAnswers — homepage intent block (2026-10-29, "Prometheus plan" step 2).
 * One H2 per question a buyer actually asks an assistant, answered in two or three
 * sentences with dated, sourced figures, each linking to the hub page that goes deeper.
 * Figures must match backend/data/guide_facts.json and sofia_brain/CATALOGUE.md.
 */
const QA = [
  {
    q: "What property can I buy with Sofia Sands?",
    a: "Our own instructions in Dubai and Ras Al Khaimah, plus more than 1,500 off-plan projects from developers we track, each with its price from, payment plan and handover date.",
    href: "/listings",
    cta: "See every property for sale",
  },
  {
    q: "Dubai or Ras Al Khaimah: where should I buy?",
    a: "Dubai Marina and JBR registered a median of AED 4,448 per sq ft in September 2026 (Dubai Land Department). Al Marjan Island was asking a median of AED 2,353 and Mina Al Arab AED 1,354 per sq ft (our RAK Waterfront Pulse, 26 October 2026). Wynn Al Marjan Island opens in September 2027.",
    href: "/why-invest-in-ras-al-khaimah",
    cta: "Why Ras Al Khaimah, before Wynn opens",
  },
  {
    q: "How much does it cost to buy a property in Dubai?",
    a: "Budget the Dubai Land Department transfer fee of 4% of the price, an AED 580 admin fee and the trustee office fee of AED 4,200 plus VAT above AED 500,000. In Ras Al Khaimah the buyer pays 2% and the seller 2% (RAK Municipality).",
    href: "/dubai-real-estate/buyer-guides/total-fees-and-closing-costs-buying-property-dubai",
    cta: "Every buying cost, itemised",
  },
  {
    q: "How much deposit do I need?",
    a: "A UAE resident buying a first home up to AED 5 million can borrow up to 80%, so the minimum cash deposit is 20% (Central Bank of the UAE). Off-plan purchases are paid to the developer in stages, usually from a 5% to 20% booking amount.",
    href: "/dubai-real-estate/buyer-guides/how-much-deposit-to-buy-property-in-dubai",
    cta: "Deposits for resale and off-plan",
  },
  {
    q: "Can foreigners buy, and does it give a Golden Visa?",
    a: "Yes. Buyers of any nationality can own freehold in Dubai's designated areas and in Ras Al Khaimah's freehold zones, including Al Marjan Island, Mina Al Arab and Al Hamra. Property worth AED 2 million or more qualifies for the 10-year Golden Visa, mortgaged or not.",
    href: "/dubai-real-estate/golden-visa/",
    cta: "Golden Visa through property",
  },
  {
    q: "How do I know an off-plan project is safe?",
    a: "Dubai Law 8 of 2007 requires off-plan payments to go into a RERA-approved escrow account. Check the project number and its escrow account in the Dubai REST app before you pay anything, and confirm the broker's RERA card.",
    href: "/dubai-real-estate/buyer-guides/check-project-registered-and-escrow-before-buying-off-plan",
    cta: "The checks before you pay",
  },
  {
    q: "What are prices doing in my area?",
    a: "Each Dubai area has a page of registered sales from Dubai Land Department open data, updated daily, and each area we cover lists the off-plan projects on sale with prices from.",
    href: "/for-sale",
    cta: "Projects and prices by area",
  },
  {
    q: "What is Bay Views on Hayat Island?",
    a: "Our flagship: one full floor of 12 sea-view residences by RAK Properties on Hayat Island, Mina Al Arab, sold as a single transaction at AED 16,200,000 (AED 1,730 per sq ft). It is handed over and ready now.",
    href: "/bay-views",
    cta: "Bay Views, Hayat Island",
  },
];

export default function BuyerAnswers() {
  return (
    <section className="bg-bone px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="buyer-answers">
      <div className="max-w-6xl">
        <div className="overline overline-gold">Buyer questions, answered</div>
        <h2 className="font-display text-h1 leading-[1.08] tracking-tightest text-ink mt-6 mb-14">
          Buying in Dubai &amp; Ras Al Khaimah,
          <br />
          <em className="italic text-gold">in plain numbers.</em>
        </h2>
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
          {QA.map((x) => (
            <article key={x.q} className="border-t border-ink/15 pt-6">
              <h3 className="font-display text-[1.6rem] md:text-[1.9rem] leading-snug text-ink">{x.q}</h3>
              <p className="text-ink/70 text-[1.02rem] leading-relaxed font-light mt-4">{x.a}</p>
              <a href={x.href} className="mt-5 inline-flex items-center gap-2 link-gold text-[0.72rem] tracking-caps uppercase font-medium text-ink">
                {x.cta} <span aria-hidden="true">&rarr;</span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
